<div class="container position-relative">

    <div class="py-5 mechknow-profile row">

        <div class="col-md-4 mb-3">
            <div class="bg-white rounded shadow-sm sticky_sidebar overflow-hidden">
                <a class="editprofile" (click)="ShowProfile()" style="cursor: pointer;">
                    <div class="d-flex align-items-center p-3">
                        <div class="left mr-3">
                            <img src="../../assets/img/noprofileimg.png" *ngIf="storeUserSettings.ProfileImage=='' || storeUserSettings.ProfileImage==null" class="rounded-circle" style="width:70px;height:70px;border:2px solid #ea0029;">
                            <img id="Image" *ngIf="imgURL" [src]="imgURL" name="Image" alt="" class="rounded-circle" style="width:70px;height:70px;border:2px solid #ea0029;"/>
                            <img id="Image" *ngIf="!imgURL && storeUserSettings.ProfileImage!=''" name="Image" alt="" class="rounded-circle" style="width:70px;height:70px;border:2px solid #ea0029;" src="{{storeSettings.apiCallingUrl+'Images/'}}{{storeUserSettings.ProfileImage}}"/><br>
                            <!-- <img alt="#" src="../../assets/img/user1.jpg" class="rounded-circle" style="cursor:pointer;"><br> -->
                            <label for="file-upload" class="custom-file-upload"><i class="feather-camera ml-3"></i></label>
                            <input #ImageResourcefile id="file-upload" type="file" style="display:none;" (change)="ImagefileChange($event,'ImageResourcefile')"
                                        accept="image/*" > 
                        </div>
                        <div class="right mb-4">
                            <h6 class="mb-1 font-weight-bold editpro">{{storeUserSettings.FirstName}} {{storeUserSettings.LastName}} <i
                                    class="feather-check-circle text-success"></i></h6>
                            <p class="text-muted m-0 small">{{storeUserSettings.Email}}</p>
                        </div>
                    </div>
                </a>
                
                <div class="bg-white profile-details">

                    <a  (click)="chkEvent(1)"
                        class="d-flex w-100 align-items-center border-bottom p-3">
                        <div class="left mr-3">
                            <h6 class="font-weight-bold mb-1 text-dark">Address</h6>
                            <p class="small text-muted m-0">Delivery address</p>
                            <!-- <p class="small text-muted m-0">Add or remove a delivery address</p> -->
                        </div>
                        <div class="right ml-auto">
                            <h6 class="font-weight-bold m-0"><i class="feather-chevron-right"></i></h6>
                        </div>
                    </a>

                    <a href="terms.html" class="d-flex w-100 align-items-center border-bottom px-3 py-4">
                        <div class="left mr-3">
                            <h6 class="font-weight-bold m-0 text-dark"><i
                                    class="feather-info bg-success text-white p-2 rounded-circle mr-2"></i> Term of use
                            </h6>
                        </div>
                        <div class="right ml-auto">
                            <h6 class="font-weight-bold m-0"><i class="feather-chevron-right"></i></h6>
                        </div>
                    </a>
                    <a href="privacy.html" class="d-flex w-100 align-items-center px-3 py-4">
                        <div class="left mr-3">
                            <h6 class="font-weight-bold m-0 text-dark"><i
                                    class="feather-lock bg-warning text-white p-2 rounded-circle mr-2"></i> Privacy
                                policy</h6>
                        </div>
                        <div class="right ml-auto">
                            <h6 class="font-weight-bold m-0"><i class="feather-chevron-right"></i></h6>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-md-8 mb-3" *ngIf="showaddress">
            <div class="rounded shadow-sm p-4 bg-white">

                <div class="row">

                    <div class="col-md-8">
                        <h5 class="mb-4">My Address</h5>
                    </div>
                    <div class="col-md-4">
                        <button class="btn btn-primary" style="float: right;" data-toggle="modal" data-target="#addressModal" 
                        #closebutton (click)="addAddress({ID:0,City:'',Zip:'',Address:'',ContactNo:'',AddressType:'Home'})">Add Address
                             <i class="feather-plus-circle float-right mx-1" style="font: size 15px;margin-top:3px;"></i></button>
                    </div>
                </div>
                <!-- <h6 class="font-weight-bold mb-4"><i class="feather-plus-circle float-right" style="font-size:19px;margin-top:-2.7rem;"></i></h6> -->
                    <div class="card mb-3" style="border-radius:15px;" *ngFor="let d of AddressList;let i = index">
                        <div class="card-body">
                            <div class="row">
                                <!-- <p >{{i+1}})</p> -->
                                <div class="col-md-6">
                                    <div class="label" style="font-weight:bold;">Address Type:</div>
                                    <p>{{d.AddressType}}</p>
                                </div>
                                <div class="col-md-6">
                                    <div class="label" style="font-weight:bold;">Address:</div>
                                    <p>{{d.Address}}</p>
                                </div>
                                <div class="col-md-6">
                                    <div class="label" style="font-weight:bold;">City:</div>
                                    <p>{{d.City}}</p>
                                </div>
                                <div class="col-md-6">
                                    <div class="label" style="font-weight:bold;">Zip:</div>
                                    <p>{{d.Zip}}</p>
                                </div>
                                <div class="col-md-6">
                                    <a href="javascript:void(0);" data-toggle="modal" data-target="#addressModal" class="btn btn-block btn-light border-top" (click)="editAddress(d)">Edit</a>
                                </div>
                                <div class="col-md-6">
                                    <a  class="btn btn-block btn-light border-top" (click)="deleteAddressAlert(d)">Delete</a>
                                </div>
                            </div>
                            
                        </div>
                    </div>
            </div>
        </div>
        <div class="col-md-8 mb-3" *ngIf="!showaddress">
            
            <div class="rounded shadow-sm p-4 bg-white">
                <a class="cursor-pointer" style="float:right;border-radius: 60px;box-shadow: 0 0 4px #888;padding: 0.5em 1.6em;display:inline-block;" (click)="homeClick()" ><i class="feather-home mr-2" style="font-size:25px;color:#f00;"></i></a>

                <h5 class="mb-4">My account</h5>
                <div id="edit_profile">
                    <div>
                        <form action="my_account.html">
                            <div class="form-group">
                                <label for="exampleInputName1">First Name</label>
                                <input type="text" class="form-control" id="firstname" name="firstname" [(ngModel)]="storeUserSettings.FirstName" autocomplete="off">
                                <div *ngIf="submit && storeUserSettings.FirstName==''"><label class="validate-error">first name required*</label></div>
                            </div>
                            <div class="form-group">
                                <label for="exampleInputName1">Last Name</label>
                                <input type="text" class="form-control" id="lastname" name="lastname" [(ngModel)]="storeUserSettings.LastName" autocomplete="off">
                                <div *ngIf="submit && storeUserSettings.LastName==''"><label class="validate-error">last name required*</label></div>
                            </div>
                            <div class="form-group">
                                <label for="exampleInputNumber1">Mobile Number</label>
                                <input type="number" class="form-control" id="contact" name="contact" [(ngModel)]="storeUserSettings.Mobile" autocomplete="off">
                                <div *ngIf="submit && storeUserSettings.Mobile==''"><label class="validate-error">Contact number required*</label></div>
                                <div *ngIf="submit && storeUserSettings.Mobile!='' && !validateMobile(storeUserSettings.Mobile)"><label class="validate-error">Invalid Contact number required</label></div>
                            </div>
                            <div class="form-group">
                                <label for="exampleInputEmail1">Email</label>
                                <input type="email" class="form-control" id="email" name="email" [(ngModel)]="storeUserSettings.Email" autocomplete="off">
                                <div *ngIf="submit && storeUserSettings.Email==''"><label class="validate-error">email required*</label></div>
                                <div *ngIf="submit && storeUserSettings.Email!='' && !validateEmail(storeUserSettings.Email)"><label class="validate-error">Invalid Email</label></div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary btn-block" (click)="saveProfile()">Save Changes</button>
                                <!-- <button type="submit" class="btn btn-primary btn-block" (click)="sendEmail()">Send Email</button> -->
                            </div>
                        </form>
                    </div>
                    <div class="additional">
                        <div class="change_password my-3">
                            <a data-toggle="modal" data-target="#changepassword" #closebutton
                                class="p-3 border rounded bg-white btn d-flex align-items-center" (click)="changePasswordClick()">Change Password
                                <i class="feather-arrow-right ml-auto"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- modal popup start -->
<div class="modal"  [ngStyle]="{'display':changepasswordmodeldisplay}"   id="changepassword" role="dialog" aria-modal="true" aria-labelledby="changepasswordLabel"
    data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="changepasswordLabel">Change Password</h6>
                <button type="button" id="changepassword"  (click)="changePasswordModelClose()" #closebutton class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form class="" action="verification.html">
                    <div class="form-row">
                        <div class="col-md-12 form-group d-flex justify-content-center">
                            <h2>Change password</h2>
                        </div>

                        <div class="col-md-12 form-group">
                            <label for="exampleInputEmail1">Current Password</label>
                            <input type="password" class="form-control"  id="currentpassword" name="currentpassword" 
                            [(ngModel)]="currentpassword" autocomplete="off" (change)="changepass()">
                            <div *ngIf="submited && currentpassword==''"><label class="validate-error">Current Password required*</label></div>
                            <div *ngIf="submited && currentpassword!='' && confirmpassword!='' && newpassword!=''  && newpassword==currentpassword"><label class="validate-error">Current Password and New Password are Same</label></div>
                            <div *ngIf="validtrue"><label class="validate-error">Password Not Matched Enter Valid Password</label></div>
                        </div>
                        <div class="col-md-12 form-group">
                            <label for="exampleInputEmail1">New Password</label>
                            <input type="password" class="form-control" id="newpassword" name="newpassword" [(ngModel)]="newpassword" autocomplete="off">
                            <div *ngIf="submited && newpassword==''"><label class="validate-error">New Password required*</label></div>
                        </div>
                        <div class="col-md-12 form-group">
                            <label for="exampleInputEmail1">Confirm New Password</label>
                            <input type="password" class="form-control" id="confirmpassword" name="confirmpassword" [(ngModel)]="confirmpassword" autocomplete="off">
                            <div *ngIf="submited && confirmpassword==''"><label class="validate-error">Confirm Password required*</label></div>
                            <div *ngIf="submited && confirmpassword!='' && newpassword!='' && confirmpassword != newpassword"><label class="validate-error">password not matched*</label></div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer p-0 border-0">
                <div class="col-6 m-0 p-0">
                    <button type="button" class="btn border-top btn-lg btn-block" (click)="changePasswordModelClose()" data-dismiss="modal">Close</button>
                </div>
                <div class="col-6 m-0 p-0">
                    <button type="button" class="btn btn-primary btn-lg btn-block" (click)="saveChangePassword()">Save</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- modal popup start of Add Address -->
<div class="modal" id="addressModal"  [ngStyle]="{'display':addressmodaldisplay}"  role="dialog" aria-modal="true" aria-labelledby="addressModalLabel"
    data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title" id="addressModalLabel">Add Address</h6>
                <button type="button" id="addressModal" (click)="addressModalClose()" #closebutton class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form class="" action="verification.html">

                    <div class="form-row">
                        <div class="col-md-12 form-group">
                        <label class="form-label">Delivery Area<span class="validate-error" >*</span></label>
                        <div class="input-group">
                            <select  class="form-control"  id="Zip" name="Zip"  [(ngModel)]="Zip" (change)="setLocation($event)"  >
                                <option    value="0">Select Location</option>
                            
                                <option *ngFor="let d of lstDeliveryLocation"  value={{d.ZipCode}}>{{d.LocationName}}</option>
                                
                              </select>
                             
                        </div>
                        <div *ngIf="submitted && Zip==''" 
                        ><label class="validate-error"> Delivery Area required</label></div>
                    </div>
                        <div class="col-md-12 form-group"><label class="form-label">Complete Address<span class="validate-error" >*</span></label>
                            <textarea  rows="4" cols="50" class="form-control"  [(ngModel)]="Address"  id="Address" name="Address" placeholder="Address"></textarea>
                        
                            <div *ngIf="submitted && Address==''" 
                            ><label class="validate-error"> Address required</label></div>
                        </div>
                        <div class="col-md-12 form-group">
                            <label for="exampleInputName1">Contact No<span class="validate-error" >*</span></label>
                            <input type="text" class="form-control" id="ContactNo" name="ContactNo" placeholder="Enter Mobile No"
                            [(ngModel)]="ContactNo"
                           
                            maxlength="30"
                            
                            >
                
                            <div *ngIf="submitted && ContactNo==''" 
                            ><label class="validate-error"> Contact number required</label></div>
                
                            <div *ngIf="submitted && ContactNo!='' && !validateMobile(ContactNo)  " 
                            ><label class="validate-error">Invalid Contact number </label></div>
                
                
                            </div>
                
                        <div class="mb-0 col-md-12 form-group">
                        
                        <div class="btn-group btn-group-toggle w-100" data-toggle="buttons">
                        <label (click)="addressTypeClick('Home')"  [className]="AddressType=='Home' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'"   >
                        <input type="radio" name="options" id="option12" checked> Home
                        </label>
                        <label  (click)="addressTypeClick('Work')" [className]="AddressType=='Work' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'">
                        <input type="radio" name="options" id="option22"> Work
                        </label>
                       
                        </div>
                        </div>
                        </div>
                    
                </form>
            </div>
            <div class="modal-footer p-0 border-0">
                <div class="col-6 m-0 p-0">
                    <button type="button" (click)="addressModalClose()" class="btn border-top btn-lg btn-block" data-dismiss="modal">Close</button>
                </div>
                <div class="col-6 m-0 p-0">
                    <button type="button" class="btn btn-primary btn-lg btn-block" (click)="saveAddress()">Save Address</button>
                </div>
            </div>
        </div>
    </div>
</div>